import React from 'react';

/**
 * Знак бренда «Кольцо-e»: строчная e как незамкнутое кольцо прогресса
 * и оранжевая искра серии. viewBox 100×100, поле 22% — как у иконки приложения.
 *   tile  — на бирюзовой плашке (сайдбар, онбординг);
 *   plain — без плашки, белое кольцо (на тёмно-бирюзовой панели входа).
 */
export const BRAND_RING = 'M26.5 50H73.5A23.5 23.5 0 1 0 59.9 71.3';

export const BrandMark = ({ size = 30, variant = 'tile', className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    aria-hidden="true"
    className={['ds-brand-mark', `ds-brand-mark--${variant}`, className].filter(Boolean).join(' ')}
  >
    {variant === 'tile' && <rect width="100" height="100" rx="22" className="ds-brand-mark-tile" />}
    <path d={BRAND_RING} className="ds-brand-mark-ring" strokeWidth={size <= 20 ? 12 : 11} />
    <circle cx="69.7" cy="62.8" r="5" className="ds-brand-mark-dot" />
  </svg>
);
